import {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  getCashbackInfoOverlay,
  getCashbackInfoOverlayVisibility
} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'

import {CashbackInfoBottomSheet} from '@vio/shared/src/cashback/components/Cashback/CashbackInfoBottomSheet/CashbackInfoBottomSheet'

export const CashbackInfoBottomSheetContainer = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(getCashbackInfoOverlayVisibility)
  const value = useSelector(getCashbackInfoOverlay)?.value

  const onClose = useCallback(() => {
    dispatch(hideOverlay())
  }, [dispatch])

  return (
    <CashbackInfoBottomSheet isOpen={isOpen} onClose={onClose} value={value} />
  )
}
